; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('GoogleFontSelect', ['WebFont'], factory);
    } else {
        // Browser globals
        root.GoogleFontSelect = factory(root.WebFont);
    }
}(typeof self !== 'undefined' ? self : this, function (WebFont) {
    'use strict';

    if (WebFont == null || typeof (WebFont.load) != 'function') {
        throw new ReferenceError('Typekit Web Font Loader is required by Google Font Picker: https://github.com/typekit/webfontloader');
    }

    function Picker(element) {
        this.container = element;

        if (this.container == null) {
            return;
        }

        this.container.classList.add('-loading');

        this.control = this.container.querySelector('select');

        if (this.control == null) {
            this.container.classList.remove('-loading');
            return;
        }

        this.apiKey = this.container.dataset.apiKey;

        if (typeof(this.apiKey) != 'string') {
            this.container.classList.remove('-loading');
            this.control.disabled = true;
        }

        var listLength = this.container.dataset.listLength;
        this.sortBy = this.container.dataset.sortBy;

        this.value = this.container.dataset.value;

        this.exampletext = this.container.querySelector('[data-font-preview]');

        this.listLength = isNaN(parseInt(listLength)) ? 5000 : parseInt(listLength);

        switch (this.sortBy) {
            case 'alpha':
                this.sortBy = 'alpha';
                break;
            case 'date':
                this.sortBy = 'date';
                break;
            case 'style':
                this.sortBy = 'style';
                break;
            case 'trending':
                this.sortBy = 'trending';
                break;
            case 'popularity':
            default:
                this.sortBy = 'popularity';
                break;
        }

        this.load = this.load.bind(this);
        this.onload = this.onload.bind(this);
        this.onerror = this.onerror.bind(this);
        this.onchange = this.onchange.bind(this);
        this.update = this.update.bind(this);
        this.onfontload = this.onfontload.bind(this);
        this.onfontfail = this.onfontfail.bind(this);

        this.loader = WebFont;

        this.control.addEventListener('change', this.onchange);

        this.load();
    }

    Picker.prototype = {
        fonts: [],
        load: function() {
            var endpoint = 'https://www.googleapis.com/webfonts/v1/webfonts';

            fetch(endpoint + '?key=' + this.apiKey + '&sort=' + this.sortBy, {
                method: 'GET'
            }).then(function (res) {
                return res.ok ? res.json() : Promise.reject(res);
            })
            .then(this.onload)
            .catch(this.onerror);
        },
        onload: function(data) {
            this.fonts = data.items.filter(function (el) {
                return el.category == 'sans-serif' || el.category == 'serif' || el.category == 'monospace'
            });

            var googleFontsGroup = this.control.querySelector('optgroup[data-group="google"]')

            this.fonts = this.fonts.filter(function (el) {
                return el.subsets.indexOf('latin') >= 0 || el.subsets.indexOf('latin-ext') >= 0;
            });

            for (var i = 0; i < this.listLength; i++) {
                var font = this.fonts[i];

                if (typeof (font) == 'undefined') {
                    break;
                }

                var opt = document.createElement('option');
                opt.innerHTML = font.family;
                opt.value = '\'' + font.family + '\',' + font.category;
                opt.dataset.fontFamily = font.family;
                opt.dataset.fontCategory = font.category;

                if (this.value) {
                    var fam = this.value.split(',')[0];
                    fam = fam.replace(/\'/gi, '');
                    opt.selected = font.family.toLowerCase() == fam.toLowerCase();
                }

                googleFontsGroup.appendChild(opt);
            }

            this.update()

            this.container.classList.remove('-loading');
        },
        onerror: function(data) {
            console.warn(data);
            this.control.disabled = true;
            this.container.classList.remove('-loading');
            this.container.classList.add('-error');
        },
        onchange: function() {
            this.update();
        },
        update: function() {
            var selected = this.control.options[this.control.selectedIndex];
            this.value = selected.value;
            this.fontFamily = selected.dataset.fontFamily;
            this.fontCategory = selected.dataset.fontCategory;

            this.container.classList.add('-loading');
            this.control.disabled = true;

            if (this.control.options[this.control.selectedIndex].parentNode.dataset.group == 'google') {
                this.loader.load({
                    google: {
                        families: [this.fontFamily]
                    },
                    active: this.onfontload,
                    inactive: this.onfontfail
                });
            }
            else {
                this.onfontload();
            }
        },
        onfontload: function() {
            this.container.classList.remove('-loading');
            this.exampletext.style.fontFamily = this.value;
            this.control.disabled = false;
        },
        onfontfail: function() {
            this.container.classList.remove('-loading');
            this.exampletext.style.fontFamily = this.value;
            this.control.disabled = false;
        }
    };

    return Picker;

}));